import React, {useRef} from 'react';
import styles from './styles';
import EditableField from '../../../OverviewContainer/EditableField';
import DatePicker from 'react-datepicker'
import moment from "moment";
import HeaderObj from '../../../TrialUI/dataTableSettings';
import MsgBanner from '../../../msgBanner';
import dataLogic from "../../Hooks/DataLogic";

const TrialConfiguration = props => {
  const headerObj = HeaderObj.headers;
  const startDate = useRef(false);
  const endDate = useRef(false);
  const handleDate = (type, value) => {
    console.log(type,value, props.data.startDate, props.data.endDate, "VAL")
    if (type === 'startDate') startDate.current = value;
    else endDate.current = value;
  }

  const Calendar = props => <DatePicker
      dateFormat='yyyy-MM-dd'
      closeOnScroll={true}
      peekNextMonth
      autoComplete='off'
      showMonthDropdown
      showYearDropdown
      dropdownMode='select'
      {...props}
    />

  const content = [
    {
      title: 'QC',
      diffProperty: 'approved',
      value: props.data.approved,
      formatDisplay: value => value,
      formSettings: [{
        type: 'radio',
        value: props.data.approved,
        options: [['Yes', 'Yes'], ['No', 'No']]
      }],
      tooltip: 'Has this trial been reviewed by study admins?'
    },
    {
      title: 'Display',
      diffProperty: 'display',
      value: props.data.display,
      formatDisplay: value => value,
      formSettings: [{
        type: 'radio',
        value: props.data.display,
        options: [['Yes', 'Yes'], ['No', 'No']]
      }],
      tooltip: 'Display this trial on XpertTrial and XpertScreen?'
    },
    {
      title: 'Priority',
      diffProperty: 'priority',
      value: props.data.priority,
      formatDisplay: value => value,
      formSettings: [{
        type: 'radio',
        value: props.data.priority,
        options: [['Yes', 'Yes'], ['No', 'No']]
      }],
      tooltip: 'If this trial has been marked as priority trial. It will be on the top of the list page.'
    },
    {
      title: 'Suspend Trial',
      diffProperty: 'suspendTrial',
      value: props.data.suspendTrial,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'suspendTrial'),
        value: props.data.suspendTrial,
      }],
      formatDisplay: value => value ? 'Suspend Until:   ' + value : value,
      customEditField: ({handleSubmit}) => <Calendar
          name="suspendTrial"
          minDate={moment().toDate()}
          selected={null}
          onChange={e => {
            let newDate = moment(e).format('ll');
            handleSubmit(newDate, true)
          }}
        />,
      tooltip: headerObj.suspendTrial.tip,
    },
    {
      title: 'Start Date',
      diffProperty: 'startDate',
      editedLogs: props.editedLogs ? props.editedLogs['startDate'] : false,
      value:  !props.data.startDate.replace(/\s/g, '').length ? '' : props.data.startDate,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'startDate'),
        value: !props.data.startDate.replace(/\s/g, '').length ? '' : props.data.startDate
      }],
      clearChangesCallback: () => startDate.current = '',
      customEditField: ({handleSubmit}) => {
        // console.log(props.diff, props.data.startDate, startDate.current, "START DATE")
        return <Calendar
          name="startDate"
          selected={
            props.diff.startDate
              ? moment(props.diff.startDate).toDate()
              : props.data.startDate.replace(/\s/g, '').length && props.data.startDate && props.data.startDate !== ''
              ? moment(props.data.startDate).toDate()
              : null
          }
          onChange={e => {
            let newDate = moment(e).format('ll');
            handleDate('startDate', newDate);
            console.log(newDate, "DATE")
            handleSubmit(newDate, true)
          }}
        />
      },
      tooltip: headerObj.startDate.tip,
      valueToCompare: props.diff.endDate || endDate.current || props.data.endDate,
    },
    {
      title: 'End Date',
      diffProperty: 'endDate',
      value: props.data.endDate,
      editedLogs: props.editedLogs ? props.editedLogs['endDate'] : false,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'endDate'),
        value: props.data.endDate
      }],
      clearChangesCallback: () => endDate.current = '',
      customEditField: ({handleSubmit}) =>  <Calendar
          name="endDate"
          selected={
            props.diff.endDate
              ?  moment(props.diff.endDate).toDate()
              : props.data.endDate && props.data.endDate !== ''
              ? moment(props.data.endDate).toDate()
              : null
          }
          onChange={e => {
            let newDate = moment(e).format('ll');
            handleDate('endDate', newDate);
            handleSubmit(newDate, true)
          }}
      />,
      tooltip: headerObj.endDate.tip,
      valueToCompare: props.diff.startDate || startDate.current || props.data.startDate ,
    },
    {
      title: 'Study Notes',
      diffProperty: 'studyNotes',
      editedLogs: props.editedLogs ? props.editedLogs['studyNotes'] : false,
      value: props.data.studyNotes,
      formSettings: [{
        type: 'textarea',
        value: props.data.studyNotes,
      }],
      tooltip: headerObj.studyNotes.tip,
    }
  ].filter(i => {
    if(props.user.instance === 'STANFORD') {
      if(i.diffProperty !== 'priority') return i
    } else return i
  })


  return(
      <div style={styles.container}>
        <MsgBanner type='editField' removable user={props.user}/>
        <div style={styles.editPanel}>
          {content.map((settings, i) => <EditableField
            setValue={props.setDiff}
            key={i}
            index={i}
            length={content.length - 1}
            diff={props.diff[settings.diffProperty]}
            settings={settings}
            zIndex={content.length - i}
            width={props.width}
          />)}
        </div>
      </div>
  )
}

export default TrialConfiguration;
